module.exports = __webpack_public_path__ + "images/0297999e21cc75a8aee3786f9f724af7.png";